export const cartReducer = (state, action) => {
    switch (action.type) {
      case "ADD_TO_CART":

        const tempstate = state.cart.filter((item) => action.payload.id === item.id);
        if (tempstate.length > 0) {
          return state;
        } else {
          return { ...state, cart: [...state.cart, { ...action.payload, qty : 1}] };
        }
        case "CHANGE_CART_QTY":
          return {
            ...state,
            cart: state.cart.filter((c) =>
              c.id === action.payload.id ? (c.qty = action.payload.qty) : c.qty
            ),
          };
          case "REMOVE_FROM_CART":
      return {
        ...state,
        cart: state.cart.filter((c) => c.id !== action.payload.id),
      };
        default:
          return state;
      }
    };
  
  export const productReducer = (state, action) => {
    switch (action.type) {
      case "SORT_BY_PRICE":
        return { ...state, sort: action.payload };
        case "FILTER_BY_SEARCH":
          return { ...state, searchQuery: action.payload };
      case "CLEAR_FILTERS":
        return { };
      default:
        return state;
    }
  };
  